export const ArchivedChatInactive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_2730_14323)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33267 0.00146484H12.6641C12.7125 0.00146484 12.7609 0.00249589 12.8093 0.00462046C14.6499 0.0848543 16.077 1.64207 15.9968 3.48273C15.9285 4.53327 15.0498 5.34655 13.9972 5.3337H1.9996C0.895257 5.3337 0 4.43845 0 3.33411C0 1.49354 1.49207 0.00146484 3.33267 0.00146484ZM1.33308 6.66678H14.6637C15.0318 6.66678 15.3303 6.96519 15.3303 7.3333V12.6656C15.328 14.5052 13.8372 15.996 11.9976 15.9982H3.9992C2.15953 15.996 0.668741 14.5052 0.666553 12.6656V7.3333C0.666553 6.96519 0.964962 6.66678 1.33308 6.66678ZM5.99879 9.99945H9.99799C10.3661 9.99945 10.6645 9.70104 10.6645 9.33293C10.6645 8.96482 10.3661 8.66641 9.99799 8.66641H5.99879C5.63068 8.66641 5.33227 8.96482 5.33227 9.33293C5.33227 9.70104 5.63068 9.99945 5.99879 9.99945Z"
        fill="url(#paint0_linear_2730_14323)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2730_14323"
        x1="8"
        y1="0.00146484"
        x2="8"
        y2="15.9982"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C0BBCF" />
        <stop offset="1" stopColor="#968FA9" />
      </linearGradient>
      <clipPath id="clip0_2730_14323">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
